import { BID_TOOLKIT_URL } from '@tempmee/awards';
import { Button } from '@tempmee/react';
import { OutlineExternalLinkIcon } from '@tempmee/react-icons';
import { RemoteConfigUtils } from '~/utils/RemoteConfigUtils';

export const WinnersToolkitButton = () => (
  <Button
    data-cy="bid-toolkit-button"
    startIcon={<OutlineExternalLinkIcon />}
    onClick={() => {
      // RemoteConfig wins so the destination can be re-pointed per environment
      // without a deploy; `BID_TOOLKIT_URL` is the shared contract default both
      // clients fall back to when the key isn't set.
      const toolkitUrl = RemoteConfigUtils.getBestInDentalToolkitUrl() || BID_TOOLKIT_URL;

      window.open(toolkitUrl, '_blank', 'noopener,noreferrer');
    }}
  >
    Winner&apos;s Toolkit
  </Button>
);
